export default class Leaderboard {
  constructor() {
    this.profile = null;
    try { this.profile = JSON.parse(localStorage.getItem('web-jump-player') || 'null'); } catch (_) {}
    if (!this.profile || !/^[a-f0-9]{64}$/.test(this.profile.token)) {
      const bytes = crypto.getRandomValues(new Uint8Array(32));
      this.profile = {token: Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join(''),
        name: `玩家${Array.from(bytes.slice(0, 2), byte => byte.toString(16).padStart(2, '0')).join('')}`, pending: null};
    }
    this.save();
  }
  save() {
    try { localStorage.setItem('web-jump-player', JSON.stringify(this.profile)); } catch (_) {}
  }
  async request(path, data) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(`/api/${path}`, {
        method: data ? 'POST' : 'GET',
        headers: {Authorization: `Bearer ${this.profile.token}`, ...(data ? {'Content-Type': 'application/json'} : {})},
        ...(data ? {body: JSON.stringify(data)} : {}), signal: controller.signal
      });
      let result;
      try { result = await response.json(); } catch (_) { throw new Error('排行榜未连接，请使用完整服务预览'); }
      if (!response.ok) {
        const error = new Error(result.error || '网络连接失败，请稍后重试');
        error.code = result.code;
        throw error;
      }
      return result;
    } finally { clearTimeout(timer); }
  }
  submit(score) {
    this.profile.pending = Math.max(this.profile.pending || 0, score);
    this.save();
    return this.flush();
  }
  async flush() {
    if (this.sending) return this.sending;
    if (this.profile.pending == null) return;
    const score = this.profile.pending;
    this.sending = this.request('score', {score, name: this.profile.name}).then(result => {
      if (this.profile.pending === score) this.profile.pending = null;
      this.save(); return result;
    }).finally(() => { this.sending = null; });
    const result = await this.sending;
    if (this.profile.pending != null) return this.flush();
    return result;
  }
  async load() {
    await this.flush();
    const [top, me] = await Promise.all([this.request('leaderboard'), this.request('me')]);
    return {players: top.players, player: me.player};
  }
  async rename(name) {
    name = name.trim();
    if (!name || Array.from(name).length > 16) throw new Error('昵称需要 1–16 个字');
    await this.request('nickname', {name});
    this.profile.name = name; this.save();
  }
}
